import http from "../http-common";

class FastQuotingCabinetDataService {
  getAll() {
    return http.get("/fastquotingcabinet");
  }

  // not ready yet
  getAllMultipleConditions(data) {
    return http.post("/fastquotingcabinet/findbymultipleconditions",data);
  }

  getFastQuotingCabinetByDescr(condition, sortfield,sorttype) {
    return http.get(`/fastquotingcabinet/search/?fastquotingcabinetnumber=${condition}&sortfield=${sortfield}&sorttype=${sorttype}`);
  }

  getCondition(condition) {
    return http.get(`/fastquotingcabinet/search/?type=${condition}`);
  }

  getMaxId() {
    return http.get(`/fastquotingcabinet/vals/maxid`);
  }

  get(id) {
    return http.get(`/fastquotingcabinet/get/${id}`);
  }

  create(data) {
    return http.post("/fastquotingcabinet", data);
  }

  update(id, data) {
    return http.put(`/fastquotingcabinet/update/${id}`, data);
  }

  delete(id) {
    return http.delete(`/fastquotingcabinet/${id}`);
  }

  deleteAll() {
    return http.delete(`/fastquotingcabinet`);
  }

  findById(id) {
    return http.get(`/fastquotingcabinet/get/${id}`);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////

}

export default new FastQuotingCabinetDataService();

// for req.query:
// use params in Postman, 
//path without /:"param" in the backend and 
//path with /?"parameter"="valueparameter" in the front end